import { render } from "./NickNameUpdateView.vue?vue&type=template&id=f93907f4&scoped=true"
import script from "./NickNameUpdateView.vue?vue&type=script&lang=js"
export * from "./NickNameUpdateView.vue?vue&type=script&lang=js"

import "./NickNameUpdateView.vue?vue&type=style&index=0&id=f93907f4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f93907f4"]])

export default __exports__